import React, { useState } from "react";
import hearderbg from "../Assest/new_logo_withshreebalaji.png";
import ServiceDetails from "../Compoemnt/ServiceDetails/ServiceDetails";

import services from "../Compoemnt/ServiceDetails/servicesData";
import serviceDetailsData from "../Compoemnt/ServiceDetails/serviceDetailsData";

export default function Services() {
  const [selectedService, setSelectedService] = useState(null);

  if (selectedService) {
    return (
      <ServiceDetails
        title={selectedService}
        items={serviceDetailsData[selectedService]}
        onBack={() => setSelectedService(null)}
      />
    );
  }

  return (
    <div className="text-gray-800 overflow-hidden">

      {/* HERO */}
      <section
        className="relative py-28 bg-cover bg-center"
        style={{ backgroundImage: `url(${hearderbg})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#2C3E5C]/70 via-[#1F2A44]/60 to-[#000]/50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Our Products
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-white/90">
            Powerful digital financial services designed for modern merchants.
          </p>
        </div>
      </section>

      {/* SERVICES GRID */}
      <section className="relative py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const Icon = service.icon;

              return (
                <div
                  key={index}
                  className="glass rounded-3xl p-8 shadow-xl
      hover:-translate-y-2 hover:shadow-2xl
      transition-all duration-300"
                >
                  <div className="mb-4">
                    <Icon className="text-4xl text-indigo-600" />
                  </div>

                  <h3 className="text-xl font-semibold mb-3 text-indigo-600">
                    {service.title}
                  </h3>

                  <p className="text-gray-600 leading-relaxed">
                    {service.desc}
                  </p>

                  <div className="mt-6">
                    <button
                      onClick={() => setSelectedService(service.title)}
                      className="text-sm font-semibold text-indigo-600 hover:underline"
                    >
                      Learn More →
                    </button>
                  </div>
                </div>
              );
            })}

          </div>
        </div>
      </section>

    </div>
  );
}
